/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Footer_ReleasesInputs */

const en_fc_footer_releases = /** @type {(inputs: Fc_Footer_ReleasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All releases`)
};

/**
* | output |
* | --- |
* | "All releases" |
*
* @param {Fc_Footer_ReleasesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_footer_releases = /** @type {((inputs?: Fc_Footer_ReleasesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Footer_ReleasesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_footer_releases(inputs)
});
export { fc_footer_releases as "fc.footer.releases" }